const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg', 'ico'])

export function resolvePreviewFileUrl(url, apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '') {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  if (!apiBaseUrl) {
    return url.startsWith('/') ? url : `/${url}`
  }
  const normalizedBase = apiBaseUrl.replace(/\/+$/, '')
  return url.startsWith('/') ? `${normalizedBase}${url}` : `${normalizedBase}/${url}`
}

export function normalizeCustomerMaterialFile(file, options = {}) {
  const previewSource = file?.previewUrl || `/api/customer/materials/files/${file?.id}/preview`
  const downloadSource = file?.downloadUrl || file?.fileUrl || `/api/customer/materials/files/${file?.id}/download`
  const extension = getFileExtension(file)
  const contentType = file?.contentType || inferContentType(extension)
  const name = file?.originalName || file?.fileName || file?.name || '附件'
  const size = file?.fileSize ?? file?.size
  const apiBaseUrl = options.apiBaseUrl ?? process.env.VUE_APP_API_BASE_URL ?? ''

  return {
    ...file,
    url: resolvePreviewFileUrl(previewSource, apiBaseUrl),
    downloadUrl: resolvePreviewFileUrl(downloadSource, apiBaseUrl),
    name,
    originalName: name,
    size,
    fileSize: size,
    contentType,
    meta: {
      id: file?.id,
      fieldCode: file?.fieldCode,
      fieldName: file?.fieldName,
      version: file?.version,
      uploadTime: file?.uploadTime
    }
  }
}

export function withBlobPreview(file, loaderKey) {
  return {
    ...file,
    previewMode: 'blob',
    previewSource: file?.previewSource || file?.url || '',
    downloadSource: file?.downloadSource || file?.downloadUrl || file?.url || '',
    previewLoaderKey: loaderKey || file?.previewLoaderKey || ''
  }
}

export function getFileExtension(file) {
  if (file?.extension) return String(file.extension).toLowerCase()
  const name = file?.originalName || file?.fileName || file?.name || file?.url || ''
  const clean = String(name).split('?')[0].split('#')[0]
  const match = clean.match(/\.([0-9a-z]+)$/i)
  return match ? match[1].toLowerCase() : ''
}

export function inferContentType(extension) {
  if (!extension) return ''
  if (extension === 'pdf') return 'application/pdf'
  if (extension === 'docx') return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  if (extension === 'doc') return 'application/msword'
  if (extension === 'xlsx') return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  if (extension === 'xls') return 'application/vnd.ms-excel'
  if (IMAGE_EXTENSIONS.has(extension)) {
    if (extension === 'jpg') return 'image/jpeg'
    if (extension === 'svg') return 'image/svg+xml'
    return `image/${extension}`
  }
  return ''
}
